import { decode as _decodeHtml } from "html-entities";
const decodeHtml = _decodeHtml;
export default (function removeHtmlEntities(eventGroup) {
  eventGroup.events.forEach((event, eventIndex, events) => {
    events[eventIndex].text = decodeHtml(event.text.replace(/<br>/g, ""));
  });
  return eventGroup;
});